export enum TranslationParam {

    amount = "amount",
    brand = "brand",
    date = "date",
    fee = "fee",
    max = "max",
    min = "min",
    name = "name",
    percent = "percent",
    total = "total",
    units = "units",
    value = "value",
}
